import { Container, Row, Col } from "react-bootstrap";
import './deviceDetails.scss'
import './global.scss'
import { Button, Input, Dropdown, Loader } from 'sfy-react'
import Header from "./trHeader";
import React, { useState, useEffect } from 'react'
import { postRequestAsync, postCoreRequestAsync } from "./genericApi";
import constants from "./constants";
import indianFlag from "./assets/india_flag.png"
import smartPhoneIcon from './assets/mobile.svg'
import tabletIcon from './assets/tablet.svg'
import smartWatchIcon from './assets/smartwatch.svg'
import laptopIcon from './assets/laptop.svg'
import ErrorModal from "./Modal/errorModal";
import './mobileLogin.scss'
import pushToAnalytics, { getTimeDiff } from "./Analytics";
const MobileVerification = (props) => {
 const { changeScreen } = props;
 const [mobileNumber, setMobileNumber] = useState("");
 const [OtpError, setOtpError] = useState("")
 const [enterTime, setEnterTime] = useState(new Date())
 const [showModal, setShowModal] = useState(false);
 const [showOtp, setShowOTP] = useState("");

 const [otp, setOTP] = useState("");
 const [showLoader, setShowLoader] = useState(false);


 useEffect(() => {
  if (OtpError) setShowModal(true);
 }, [OtpError]);

 useEffect(() => {
  const currentTime = new Date();
  console.log("currentTime", currentTime)
  setEnterTime(currentTime);
  pushToAnalytics(
   'Basic Info - Home page',
   {
    Url: window.location.href,
    Unique_Key: localStorage.getItem('ampleUniquekey')
   }
  )
 }, [])

 const on_btn_click = async () => {
  setOtpError("");
  setShowLoader(true);
  try {
   let res = await postCoreRequestAsync('/api/Consumer/requestOTP', { "MobileNo": mobileNumber, "ResendOTPRequest": "false", "CountryCode": "+91" })
   localStorage.setItem("ampleMobile", mobileNumber)
   if (res && res.success) changeScreen("otpVerification")
   setShowLoader(false);
   console.log("Time_Spent--", getTimeDiff(new Date(), enterTime))
   pushToAnalytics(
    'Basic Info - Send OTP',
    {
     Mobile_Number: mobileNumber,
     Unique_Key: localStorage.getItem('ampleUniquekey'),
     Time_Spent_On_Send_OTP_Screen: getTimeDiff(new Date(), enterTime)
    }
   )
  }
  catch (e) {
   setOtpError(e && (e.msg || e.message));
   setShowLoader(false);
  }
 }
 const closeModal = () => {
  setShowModal(false);
  setOtpError("");
 }


 return (
  <Container fluid className="p-0 m-0 g-0" style={{ backgroundColor: 'rgb(255, 255, 255)', height: "100%" }}>
   {
    showLoader ?
     <Loader />
     :
     ''
   }
   <div >
    <div style={{ padding: '24px' }}>
     <div className="paragraph_center jost-font mobile_login_header">
      Know the best exchange value for your old device
     </div>
     <div className="jost-font mobile_login_sub_header">
      What do you want to exchange?
     </div>
     <div className="psc_selction_container jost-font" style={{ marginTop: "10%" }}>
      <div className="psc_selection_first_section">
       <div className="psc_selection-bx1" style={{ width: "125px", height: "104px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", border: "2px solid #DE3818", borderRadius: "10px" }}>
        <div style={{ width: "80px", height: "80px", display: "flex", justifyContent: "center", alignItems: "center" }} ><img alt="" src={smartPhoneIcon} /></div>
        <div className="jost-font" style={{ fontSize: "12px", fontWeight: "600", color: "#DE3818", lineHeight: "17.34px" }} >Smartphone</div>
       </div>
       <div className="psc_selection-bx2" style={{ width: "125px", height: "104px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", border: "2px solid #70707066", borderRadius: "10px", opacity: "40%" }}>
        <div style={{ width: "80px", height: "80px", display: "flex", justifyContent: "center", alignItems: "center" }} ><img alt="" src={tabletIcon} /></div>
        <div className="jost-font" style={{ fontSize: "12px", color: "#000", fontWeight: "300", lineHeight: "17.34px" }} >Tablet</div>
       </div>

      </div>
      <div className="psc_selection_next_section jost-font" style={{}}>
       <div className="psc_selection-bx3" style={{ width: "125px", height: "104px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", border: "2px solid #70707066", borderRadius: "10px", opacity: "40%" }}>
        <div style={{ width: "80px", height: "80px", display: "flex", justifyContent: "center", alignItems: "center" }} ><img alt="" src={smartWatchIcon} /></div>
        <div className="jost-font" style={{ fontSize: "12px", color: "#000", fontWeight: "300", lineHeight: "17.34px" }} >Smartwatch</div>
       </div>
       <div className="psc_selection-bx4" style={{ width: "125px", height: "104px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", border: "2px solid #70707066", borderRadius: "10px", opacity: "40%" }}>
        <div style={{ width: "80px", height: "80px", display: "flex", justifyContent: "center", alignItems: "center" }} ><img alt="" src={laptopIcon} /></div>
        <div className="jost-font" style={{ fontSize: "12px", color: "#000", fontWeight: "300", lineHeight: "17.34px" }} >Laptop</div>
       </div>
      </div>
     </div>
     <Row>

      <div className="mobile_login_input_section_container">
       <Input
        label={"Mobile Number"}
        labelAlign='top'
        placeholder='Enter Mobile Number' maxLength={10}
        inputType='tel'
        value={mobileNumber}
        isDisabled={false}
        handleOnChange={(e) => {
         let m = e.target.value;
         if (/^\d*$/.test(m) && m.length <= 10) {
          setMobileNumber(e && e.target.value);
          setOtpError("");
         }
        }}
        className={{ inputContainer: 'user-details-input mobile_login_input_section', label: 'input-container-label jost-font subheader_text_color' }}
        id='input-username-id'
       >
        <div className="mobileNumberFlagBlock" >
         <img style={{ textAlign: "center", width: '28px', height: 'auto' }} src={indianFlag}></img>
         <p style={{ textAlign: "center", margin: "5px", color: "#757575" }}>+91</p>
        </div>
       </Input>
      </div>
     </Row>
     <div className="jost-font subheader_text_color mobile_login_note">
      <div className="mobile_login_input_section">Note: We will send an OTP to verify your mobile number</div>
     </div>
    </div>
   </div>
   {OtpError && <ErrorModal error={OtpError} showModal={showModal} closeModal={closeModal} onClick={closeModal} /> || ""}

   {/*    {OtpError && <div className="jost-font" style={{ padding:'20px',  display: "flex", alignItems: "center", justifyContent: "center" }}>
    <span style={{ color: "red", size: "16px" }}>
     {OtpError}
    </span>
   </div>} */}
   <div>
    <Container fluid className="m-0 g-0" style={{ padding: '20px 20px 30px 20px', height: "100%" }}>
     <Row>
      <Col xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
       <Button type='button' style={{ fontSize: "0.8rem" }} text="Send OTP" classes='pwa-continue-btn' disabled={OtpError || ((mobileNumber.length != 10) && !showOtp) || (showOtp && otp.length != 6)}
        handleOnClick={on_btn_click} >
       </Button>
      </Col>
     </Row>
    </Container>
   </div>


  </Container>
 );
}
export default MobileVerification;